export function getInsurancePayersCount(tx) {
  return tx.length
}
